module.exports = __webpack_public_path__ + "8bbcb54ee726ac60b27f4fa4dc42766d.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/news/img1_3.jpg
// module id = 314
// module chunks = 0